#!/usr/bin/env node

import { Command } from 'commander';
import { readFileSync } from 'fs';
import { fileURLToPath } from 'url';
import { dirname, join } from 'path';
import { setup } from './setup';
import { build } from './build';
import { deploy } from './deploy';
import { dev } from './dev';
import { start } from './start';
import { loadEnv } from './config';

const __filename = fileURLToPath(import.meta.url);
const __dirname = dirname(__filename);
const packageJson = JSON.parse(readFileSync(join(__dirname, '../../package.json'), 'utf-8'));

const program = new Command()
  .name('modelence')
  .description('Modelence CLI tool')
  .version(packageJson.version);

program
  .command('setup')
  .description('Setup Modelence environment variables')
  .requiredOption('-t, --token <token>', 'Modelence setup token')
  .option('-h, --host <host>', 'Modelence host', 'https://cloud.modelence.com')
  .action(async (options) => {
    await setup(options);
  });

program
  .command('build')
  .description('Build the application')
  .action(async () => {
    await loadEnv();
    await build();
  });

program
  .command('deploy')
  .description('Deploy to Modelence Cloud')
  .requiredOption('-a, --app <app>', 'Application alias')
  .requiredOption('-e, --env <env>', 'Environment alias')
  .option('-h, --host <host>', 'Modelence host')
  .action(async (options) => {
    await loadEnv();
    await deploy(options);
  });

program
  .command('dev')
  .description('Start development server')
  .action(async () => {
    await loadEnv();
    dev();
  });

program
  .command('start')
  .description('Start production server')
  .action(async () => {
    await loadEnv();
    start();
  });

program.parse(process.argv);
